import * as dom from '../../util/easy-dom'; // eslint-disable-line no-unused-vars
import {cmptDynamicWidth} from '../../util/cmpt-common-features';

export default function (elem, attrs, ctx) {
	const domUserName = elem.find('.sk--user-name')[0];
	cmptDynamicWidth('impersonated-user', elem, domUserName._.innerText, 30, 'bold 18px');
};
